import Vue from 'vue/dist/vue.esm'
import ReimbursementRequest from 'components/storefront/reimbursement-request.vue'

export default function buildReimbursementRequest(element) {
  new Vue({
    el: element,
    components: {
      ReimbursementRequest
    }
  })
}
